export const SIZES = {
  MEDIUM: 'm',
  LARGE: 'l',
  SMALL: 'sm',
  EXTRA_SMALL: 'xs',
} as const;

type Sizes = typeof SIZES;
export type Size = Sizes[keyof Sizes];
